import React, { useContext, useEffect } from 'react'
import { Box, PageContainerMain } from '../../../Components/Layout'
import { FullVideoCon } from '../SingleVideo/components/FullVideoCon'
import { AdditionalVideos } from './components/AdditionalVideos/AdditionalVideos'
import { AdUnit } from '../../../Components/Ads/AdUnit'
import { colors } from '../../../Components/consts'
import { VideoGroupContext } from '../../../Context/VideoContext/VideoGroupContext'
import { Head } from '../../../Components/Typography/Text.styles'

const VideoGroup: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { loading, mediaId, mainVideo, videoGroup, tag } = useContext(VideoGroupContext)!

  useEffect(() => {
    if (!mediaId && !tag) {
      return
    }
  }, [videoGroup, mediaId])

  return (
    <>
      <PageContainerMain backgroundColor={colors.darkBackground}>
        <Box vertMargins={2} boxColor={colors.darkBackground}>
          {!loading && mediaId && mainVideo && (
            <>
              <Head colorTheme={'dark'}>{mainVideo?.title}</Head>
              <FullVideoCon mediaId={mediaId} mediaItem={mainVideo} />
            </>
          )}
        </Box>
        <Box noMargin boxColor={colors.darkBackground}>
          <AdUnit bannerType="bannerMain" aria-label="Video group page ad" />
          <AdditionalVideos />
        </Box>
      </PageContainerMain>
    </>
  )
}
export default VideoGroup
